module.exports = __webpack_public_path__ + "static/media/slide3.3e6e9200.jpg";